import { render } from "./warehouse-list.vue?vue&type=template&id=0efe044a"
import script from "./warehouse-list.vue?vue&type=script&lang=js"
export * from "./warehouse-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__